import { graphql } from "@/__graphql__";
import { UpdateLocationInput } from "@/__graphql__/graphql";
import { Skeleton, notification } from "antd";
import { useNavigate, useParams } from "react-router";
import { useMutation, useQuery } from "urql";
import { UpdateLocationScreenImpl } from "./UpdateLocationScreenImpl";

const RelationQuery = graphql(`
  query Dashboard__UpdateLocationScreen__RelationQuery {
    relation {
      id
      locations {
        id
        name
        contactPersons {
          id
          contactPerson {
            id
            name
            emailAddresses
            phoneNumbers
          }
        }
        locale
        address {
          id
          street
          extraDetails
          postalCode
          city
          country
          coordinates {
            latitude
            longitude
          }
        }
        deletedAt
      }
    }
  }
`);

const UpdateLocationMutation = graphql(`
  mutation Dashboard__UpdateLocationScreen__UpdateLocationMutation($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      location {
        id
        name
        contactPersons {
          id
          contactPerson {
            id
            name
            emailAddresses
            phoneNumbers
          }
        }
        locale
        address {
          id
          street
          extraDetails
          postalCode
          city
          country
          coordinates {
            latitude
            longitude
          }
        }
        deletedAt
      }
    }
  }
`);

export default function UpdateLocationScreen() {
  const navigate = useNavigate();
  const { locationId } = useParams();

  const [{ data, fetching }] = useQuery({
    query: RelationQuery,
    pause: locationId === undefined,
  });

  const [{ fetching: isSubmitting }, updateLocationAsync] = useMutation(UpdateLocationMutation);

  if (locationId === undefined) {
    return null;
  }

  const location = data?.relation?.locations.find(x => x.id === locationId);
  if (fetching || location === undefined) {
    return <Skeleton />;
  }

  const relationId = data?.relation?.id ?? "";

  const handleUpdateLocation = async (updates: Omit<UpdateLocationInput, "locationId" | "relationId">) => {
    try {
      await updateLocationAsync({
        input: {
          ...updates,
          locationId,
          relationId,
        },
      });

      notification.success({ title: "Locatiegegevens aangepast" });
      navigate("/");
    } catch {
      notification.error({ title: "Er ging iets mis bij het aanpassen van de locatiegegevens." });
    }
  };

  return (
    <UpdateLocationScreenImpl
      isSubmitting={isSubmitting}
      location={location}
      relationId={relationId}
      onUpdateLocation={handleUpdateLocation}
    />
  );
}
